import React, { FunctionComponent, ReactNode, useState } from 'react';
import styled from 'styled-components';
import { Color } from '../../../config/Color';
import { BodyXXS } from '../../styles/Typography';

type Props = {
  showFullTitle: string;
  hideFullTitle: string;
  /** Full legal text, one paragraph per entry. */
  fullText: string[];
  /** Prefix for the toggle's and the full text's test ids. */
  testId: string;
  /** Shown after the full text, e.g. a privacy policy link. */
  children?: ReactNode;
};

/** The "Show full details" toggle and the full legal text, rendered under a consent's summary. */
export const FullDetails: FunctionComponent<Props> = (props) => {
  const [showFull, setShowFull] = useState(false);

  return (
    <>
      <ExpanderButton
        type="button"
        aria-expanded={showFull}
        data-testid={`${props.testId}-toggle`}
        onClick={() => setShowFull(!showFull)}
      >
        {showFull ? props.hideFullTitle : props.showFullTitle}
        <Chevron aria-hidden>{showFull ? '▴' : '▾'}</Chevron>
      </ExpanderButton>
      {showFull && (
        <FullText data-testid={`${props.testId}-full`}>
          {props.fullText.map((paragraph, index) => (
            <BodyXXS key={index} style={{ textAlign: 'left' }}>
              {paragraph}
            </BodyXXS>
          ))}
          {props.children}
        </FullText>
      )}
    </>
  );
};

const ExpanderButton = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  margin: ${({ theme }) => `${theme.spacing._8px} 0 0 ${theme.spacing._8px}`};
  color: ${Color.content.default};
  font-size: ${({ theme }) => theme.fontSize.xs};
  text-decoration: underline;
  cursor: pointer;
`;

const Chevron = styled.span`
  margin-left: ${({ theme }) => theme.spacing._4px};
  font-size: ${({ theme }) => theme.fontSize.xxs};
`;

const FullText = styled.div`
  margin-top: ${({ theme }) => theme.spacing._8px};
  padding-left: ${({ theme }) => theme.spacing._8px};
  border-left: 2px solid ${Color.surface.muted};
`;
